
export default {
    state: {
        currWord: null,
        language: 'heb',
        family: []
    },
    getters: {
        currWord(state) {
            return state.currWord
        },
        family(state) {
            return state.family
        },
        language(state) {
            return state.language
        }
    },
    mutations: {
        setCurrWord(state, { currWord }) {
            state.currWord = currWord
        },
        clearCurrWord(state) {
            state.currWord = null
        },
        setFamily(state, { family }) {
            state.family = family
        },
        setLanguage(state, { language }) {
            state.language = language
        }
    },
    actions: {

    }
}


// WEBPACK FOOTER //
// ./src/store/dictionary.store.js